import React, { useEffect, useState } from 'react';
import { Upload, Download, Check, Trash2 } from 'lucide-react';
import api from '../../api/client';

// Pagamento corsi → Modello ricevuta: il file Word con le {{variabili}} da cui nascono le ricevute.
// Vale l'ultimo caricato (o quello rimesso attivo); i precedenti restano qui.
// base = '/ricevute' (corsi) o '/ricevute-asd' (ricevute ad altre associazioni, con il suo testo in `spiegazione`).
export default function RicevuteModello({ puoModificare, puoEliminare, base = '/ricevute', spiegazione = null }) {
  const [modelli, setModelli] = useState([]);
  const [info, setInfo] = useState({ variabili: [], sezioni: [] });
  const [nome, setNome] = useState('');
  const [file, setFile] = useState(null);
  const [invio, setInvio] = useState(false);
  const [msg, setMsg] = useState(null);

  const carica = () => api.get(`${base}/modelli`).then(r => setModelli(r.data)).catch(() => setModelli([]));
  useEffect(() => {
    carica();
    api.get(`${base}/variabili`).then(r => setInfo(r.data)).catch(() => {});
  }, [base]); // eslint-disable-line

  const leggi = (f) => new Promise((ok, ko) => { const r = new FileReader(); r.onload = () => ok(String(r.result).split(',')[1] || ''); r.onerror = ko; r.readAsDataURL(f); });
  const invia = async () => {
    if (!file) return;
    setInvio(true); setMsg(null);
    try {
      await api.post(`${base}/modelli`, { nome: nome || file.name.replace(/\.docx$/i, ''), dati: await leggi(file) });
      setFile(null); setNome(''); setMsg({ ok: true, t: 'Modello caricato: da ora le ricevute usano questo.' });
      carica();
    } catch (e) { setMsg({ ok: false, t: e.response?.data?.error || 'Caricamento non riuscito' }); }
    finally { setInvio(false); }
  };
  const attiva = async (m) => {
    if (!window.confirm(`Usare di nuovo "${m.nome}" per le ricevute?`)) return;
    try { await api.put(`${base}/modelli/${m.id}/attiva`); carica(); } catch (e) { alert(e.response?.data?.error || 'Errore'); }
  };
  const elimina = async (m) => {
    if (!window.confirm(`Eliminare il modello "${m.nome}"? Non si può annullare.`)) return;
    try { await api.delete(`${base}/modelli/${m.id}`); carica(); } catch (e) { alert(e.response?.data?.error || 'Errore'); }
  };
  const scarica = async (m) => {
    try {
      const r = await api.get(`${base}/modelli/${m.id}/file`, { responseType: 'blob' });
      const u = URL.createObjectURL(r.data); const a = document.createElement('a'); a.href = u; a.download = `${m.nome}.docx`; a.click(); URL.revokeObjectURL(u);
    } catch { alert('Download non riuscito'); }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {spiegazione ? <div style={st.card}><div style={st.titolo}>COME FUNZIONA</div>{spiegazione}</div> : <div style={st.card}>
        <div style={st.titolo}>COME FUNZIONA</div>
        <p style={st.p}>Le ricevute nascono da un file <b>Word (.docx)</b> con i dati scritti tra doppie graffe, per esempio <code>{'{{cognome}}'}</code> o <code>{'{{totale}}'}</code>. Ogni corsista ha <b>una ricevuta per ciclo</b>, con il numero progressivo dell'anno dato la prima volta che la si genera (dal bottone <b>Ricevuta</b> nella tabella dei corsi, o dalla persona nel suo portale). Finché non è saldata il PDF esce con la scritta <b>NON PAGATA</b> in trasparenza.</p>
        <p style={st.p}>Il pacchetto compare all'<b>importo finale</b> della persona (se le hai fatto un prezzo diverso, lo sconto non si vede); il tesseramento ha la sua parte con il numero di tessera ASI B della stagione.</p>
      </div>}

      <div style={st.card}>
        <div style={st.titolo}>MODELLI</div>
        {modelli.length === 0 && <p style={st.p}>Nessun modello caricato: senza modello le ricevute non si possono generare.</p>}
        {modelli.map(m => (
          <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0', borderTop: '1px solid var(--border)', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 200 }}>
              <div style={{ fontWeight: 600, fontSize: 'var(--font-size-sm)' }}>{m.nome}</div>
              <div style={st.meta}>{new Date(m.created_at).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' })}{m.caricato_da ? ` · ${m.caricato_da}` : ''}</div>
            </div>
            {m.attivo ? <span style={{ ...st.badge, color: '#22C55E', borderColor: '#22C55E60' }}><Check size={11} /> IN USO</span>
              : puoModificare && <button style={st.btn} onClick={() => attiva(m)}>USA QUESTO</button>}
            <button style={st.btn} onClick={() => scarica(m)}><Download size={13} /> SCARICA</button>
            {puoEliminare && !m.attivo && <button style={{ ...st.btn, color: '#EF4444' }} title="Elimina modello" onClick={() => elimina(m)}><Trash2 size={13} /></button>}
          </div>
        ))}
        {puoModificare && (
          <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid var(--border)', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div style={{ flex: '1 1 220px' }}>
              <label style={st.label}>NOME (FACOLTATIVO)</label>
              <input style={st.inp} value={nome} maxLength={120} onChange={e => setNome(e.target.value)} placeholder="es. Ricevuta corsi 2026/2027" />
            </div>
            <label style={{ ...st.btn, cursor: 'pointer' }}>
              <Upload size={13} /> {file ? file.name : 'SCEGLI IL FILE .DOCX'}
              <input type="file" accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document" style={{ display: 'none' }} onChange={e => { setFile(e.target.files?.[0] || null); setMsg(null); }} />
            </label>
            <button style={{ ...st.btn, background: '#C24B08', color: '#fff', borderColor: '#C24B08', opacity: file ? 1 : 0.5 }} disabled={!file || invio} onClick={invia}>{invio ? 'CARICO…' : 'CARICA E USA'}</button>
          </div>
        )}
        {msg && <p style={{ ...st.p, color: msg.ok ? '#22C55E' : '#EF4444', marginTop: 8 }}>{msg.t}</p>}
        <p style={{ ...st.meta, marginTop: 8 }}>Al caricamento il file viene provato: se una variabile è scritta male te lo dice subito. Il formato .doc vecchio non va bene: da Word "Salva con nome" → .docx.</p>
      </div>

      <div style={st.card}>
        <div style={st.titolo}>VARIABILI DA METTERE NEL MODELLO</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '4px 14px', fontSize: 'var(--font-size-sm)' }}>
          {info.variabili.map(v => <React.Fragment key={v.chiave}><code style={st.code}>{`{{${v.chiave}}}`}</code><span>{v.descrizione}</span></React.Fragment>)}
        </div>
        <div style={{ ...st.titolo, marginTop: 14 }}>PARTI CHE COMPAIONO SOLO SE SERVE</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '4px 14px', fontSize: 'var(--font-size-sm)' }}>
          {info.sezioni.map(v => <React.Fragment key={v.chiave}><code style={st.code}>{`{{${v.chiave}}}`}</code><span>{v.descrizione}</span></React.Fragment>)}
        </div>
        <p style={{ ...st.meta, marginTop: 8 }}>Mettile ognuna su una riga a sé: la riga con <code>{'{{#con_tesseramento}}'}</code>, poi il testo, poi la riga con <code>{'{{/con_tesseramento}}'}</code>.</p>
      </div>
    </div>
  );
}

const st = {
  card: { background: 'var(--bg-card)', borderRadius: 'var(--radius-card, 14px)', padding: '16px 18px', boxShadow: 'var(--shadow-card)' },
  titolo: { fontSize: 'var(--font-size-xs)', fontWeight: 700, letterSpacing: '1.5px', color: 'var(--text-muted)', marginBottom: '8px' },
  p: { fontSize: 'var(--font-size-sm)', lineHeight: 1.55, margin: '0 0 6px' },
  meta: { fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)' },
  label: { display: 'block', fontSize: 'var(--font-size-xs)', fontWeight: 700, color: 'var(--text-muted)', marginBottom: 4 },
  inp: { width: '100%', padding: '8px 10px', borderRadius: 12, border: '1px solid var(--border2)', background: 'var(--bg-input)', color: 'var(--text)', fontSize: 'var(--font-size-sm)' },
  btn: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 12px', borderRadius: 999, border: '1px solid var(--border2)', background: 'var(--bg-input)', color: 'var(--text)', fontSize: 'var(--font-size-xs)', fontWeight: 700, cursor: 'pointer' },
  badge: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 999, border: '1px solid', fontSize: 'var(--font-size-xs)', fontWeight: 700 },
  code: { fontFamily: 'ui-monospace, Menlo, Consolas, monospace', fontSize: 12, background: 'var(--bg-input)', padding: '1px 6px', borderRadius: 6, whiteSpace: 'nowrap' },
};
